module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_6.783dcea4.jpg";